import { renderDateCell } from "../../../utils/date";

export default function CostAnalysisTableFields() {
    return [
        {
            field: 'organization',
            headerName: 'Organization',
            flex: 1,
            minWidth: 120,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: 'user',
            headerName: 'User',
            flex: 1.2,
            minWidth: 180,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params) => {
                const userName = params?.row?.userName || '-';
                const userEmail = params?.row?.userEmail || '-';
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '4px 0' }}>
                        <span style={{ fontWeight: 500, fontSize: 13, color: 'inherit' }}>{userName}</span>
                        <span style={{ opacity: 0.6, fontSize: 11 }}>{userEmail}</span>
                    </div>
                );
            },
        },
        {
            field: 'projectKey',
            headerName: 'Project Key',
            flex: 0.7,
            minWidth: 100,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: 'testcaseKey',
            headerName: 'Testcase Key',
            flex: 0.7,
            minWidth: 100,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: 'testGroupKey',
            headerName: 'Test Group Key',
            flex: 0.7,
            minWidth: 100,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: 'testLaunch',
            headerName: 'Test Launch',
            flex: 0.7,
            minWidth: 100,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: 'model',
            headerName: 'Model',
            flex: 0.8,
            minWidth: 100,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: 'executionMode',
            headerName: 'Execution Mode',
            flex: 0.9,
            minWidth: 120,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: 'tokensUsed',
            headerName: 'Tokens Used',
            flex: 1.3,
            minWidth: 200,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params) => {
                const inputTokens = params?.row?.inputTokens || 0;
                const outputTokens = params?.row?.outputTokens || 0;
                const totalTokens = params?.row?.totalTokens || 0;
                return (
                    <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span style={{ opacity: 0.5, fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>Total</span>
                            <span style={{ fontWeight: 600, fontSize: 13, color: 'inherit' }}>{totalTokens.toLocaleString()}</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span style={{ opacity: 0.5, fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>In</span>
                            <span style={{ fontWeight: 500, fontSize: 13, color: 'inherit' }}>{inputTokens.toLocaleString()}</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span style={{ opacity: 0.5, fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>Out</span>
                            <span style={{ fontWeight: 500, fontSize: 13, color: 'inherit' }}>{outputTokens.toLocaleString()}</span>
                        </div>
                    </div>
                );
            },
        },
        {
            field: 'cost',
            headerName: 'Cost (USD)',
            flex: 0.7,
            minWidth: 100,
            disableColumnMenu: true,
            sortable: false,
            valueGetter: (params) => {
                return params?.row?.cost || '0.000000';
            },
            renderCell: (params) => {
                const cost = parseFloat(params?.row?.cost || '0.000000');
                return `$${cost.toFixed(6)}`;
            },
        },
        {
            field: 'executionTime',
            headerName: 'Execution Time',
            flex: 0.8,
            minWidth: 120,
            disableColumnMenu: true,
            sortable: false,
        }
    ];
}
